'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ReplaceIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ReplaceIcon">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17.4367 6.69336L15.1358 10.1446L12.4514 7.07683"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.84958 16.2861C6.40853 16.2861 4.9998 15.8587 3.8016 15.0582C2.60348 14.2575 1.66958 13.1196 1.1181 11.7882C0.56663 10.4568 0.42233 8.99195 0.703505 7.5785C0.984605 6.1652 1.67858 4.86695 2.69753 3.84792C3.71648 2.82897 5.01473 2.135 6.4281 1.8539C7.84148 1.57272 9.30645 1.71702 10.6379 2.2685C11.9692 2.81997 13.1072 3.75387 13.9078 4.95207C14.7083 6.1502 15.1357 7.55892 15.1357 8.99997V10.1458"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

ReplaceIcon.propTypes = {
  sx: PropTypes.object
}
